import type { UnifiedThemeType } from '@oneaudi/unified-web-common'; // non-standard

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return {
      '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*',
    };
  } // non-standard: added "else"
  else
    return {
      '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*',
    };
};

// non-standard START - extended getThemeName version
/**
 * Return theme name while respecting currently active design system.
 * Also respects a theme name with captial first letter
 *
 * @param defaultThemeName Legacy theme
 * @returns
 */
export const getThemeName = (
  defaultThemeName?: 'light' | 'Light' | 'dark' | 'Dark',
): UnifiedThemeType['name'] => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName && defaultThemeName.toLowerCase() === 'dark' ? 'dark' : 'light';
  } else {
    return 'dark';
  }
};
// non-standard END
